import { ResponsivePie, PieCustomLayerProps } from '@nivo/pie';

import { PieChartDataProps } from 'src/types/client/stats';

interface TotalProgressPieProps {
  data: PieChartDataProps[];
}

export default function TotalProgressPie({
  data,
}: TotalProgressPieProps): JSX.Element {
  // Define specific colors for each status
  const getColor = (id: string | number): string => {
    const colorMap: { [key: string]: string } = {
      unfinished: '#60a5fa', // Blue
      reported: '#34d399', // Green
      completed: '#a78bfa', // Purple
    };
    return colorMap[String(id)] || '#94a3b8';
  };

  return (
    <ResponsivePie
      data={data}
      margin={{ top: 20, bottom: 100 }}
      innerRadius={0.7}
      padAngle={2}
      cornerRadius={4}
      activeOuterRadiusOffset={8}
      borderWidth={0}
      colors={datum => getColor(datum.id)}
      layers={['arcs', 'legends', CenteredMetric]}
      tooltip={({ datum: { id, value, color } }) => (
        <div
          style={{
            padding: '8px 12px',
            borderRadius: 6,
            color: '#ffffff',
            background: '#1f2937',
            fontSize: '13px',
            fontWeight: 500,
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          }}
        >
          <strong>
            {id}: {value}
          </strong>
        </div>
      )}
      theme={{
        tooltip: {
          container: {
            background: '#1f2937',
          },
        },
        legends: {
          text: {
            fill: '#6a7282',
            fontSize: 12,
            fontWeight: 500,
          },
        },
      }}
      legends={[
        {
          anchor: 'bottom',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: 70,
          itemsSpacing: 12,
          itemWidth: 100,
          itemHeight: 18,
          itemTextColor: '#6a7282',
          itemDirection: 'left-to-right',
          itemOpacity: 1,
          symbolSize: 14,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#0a0a0a',
              },
            },
          ],
        },
      ]}
    />
  );
}

const CenteredMetric = ({
  dataWithArc,
  centerX,
  centerY,
}: PieCustomLayerProps<PieChartDataProps>) => {
  const unfinished = dataWithArc.find(
    datum => datum.label === 'unfinished'
  ) || {
    value: 0,
  };

  return (
    <g>
      <text
        x={centerX}
        y={centerY - 10}
        textAnchor="middle"
        dominantBaseline="central"
        style={{
          fontSize: '32px',
          fontWeight: 700,
          fill: '#0a0a0a',
        }}
      >
        {unfinished.value +
          (dataWithArc.find(d => d.label === 'reported')?.value || 0)}
      </text>
      <text
        x={centerX}
        y={centerY + 20}
        textAnchor="middle"
        dominantBaseline="central"
        style={{
          fontSize: '14px',
          fontWeight: 500,
          fill: '#6a7282',
        }}
      >
        To be completed
      </text>
    </g>
  );
};
